import { deleteDoc, doc, FieldPath, getDoc, getDocs, serverTimestamp, setDoc, updateDoc } from "firebase/firestore"
import { getMessaging, getToken } from "firebase/messaging"

export default class FirebaseMembres {
  constructor(baseDeDonnees) {
    this.baseDeDonnees = baseDeDonnees
  }

  get bdd() {
    return this.baseDeDonnees.bdd
  }

  get app() {
    return this.baseDeDonnees.app
  }

  recupererIdUtilisateurCourant() {
    return this.baseDeDonnees.recupererIdUtilisateurCourant()
  }

  async journaliserErreurEtRelancer(error, contexte) {
    return this.baseDeDonnees.journaliserErreurEtRelancer(error, contexte)
  }

  async ajouterUnMembre(pseudo, idUtilisateur, mail) {
    try {
      const docRefMembre = doc(this.bdd, "membres", idUtilisateur)
      const snapshot = await getDoc(docRefMembre)

      if (snapshot.exists()) {
        return false
      }

      await setDoc(docRefMembre, {
        pseudo,
        mail,
        creerA: serverTimestamp(),
        derniereModification: serverTimestamp(),
      })
      return true
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "ajouterUnMembre")
    }
  }

  async ajouterOuModifierUnCommentaireSurUnMembre(idMembre, commentaire) {
    try {
      const idMembreConnecte = this.recupererIdUtilisateurCourant()
      const docRefMembre = doc(this.bdd, "membres", idMembreConnecte)
      const cheminCommentaire = new FieldPath("commentaires", idMembre)
      return updateDoc(docRefMembre, cheminCommentaire, commentaire)
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "ajouterOuModifierUnCommentaireSurUnMembre")
    }
  }

  async recupererLesMembres() {
    try {
      const snapshot = await getDocs(this.baseDeDonnees.recupererCollection("membres"))
      const membres = {}

      snapshot.forEach((docSnapshot) => {
        membres[docSnapshot.id] = docSnapshot.data()
      })

      return membres
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererLesMembres")
    }
  }

  async recupererLePseudoDuMembreConnecte() {
    try {
      const idMembreConnecte = this.recupererIdUtilisateurCourant()
      const docRefMembre = doc(this.bdd, "membres", idMembreConnecte)

      const snapshot = await getDoc(docRefMembre)

      if (snapshot.exists()) {
        const data = snapshot.data()
        return data.pseudo
      }
      return null
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererLePseudoDuMembreConnecte")
    }
  }

  async recupererLePseudoDunMembre(idMembre) {
    try {
      const docRefMembre = doc(this.bdd, "membres", idMembre)
      const snapshot = await getDoc(docRefMembre)
      if (snapshot.exists()) {
        const data = snapshot.data()
        return data.pseudo
      }
      return null
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererLePseudoDunMembre")
    }
  }

  async modifierLePseudoDuMembreConnecte(pseudo) {
    try {
      const idMembreConnecte = this.recupererIdUtilisateurCourant()
      const docRefMembre = doc(this.bdd, "membres", idMembreConnecte)

      return updateDoc(docRefMembre, {
        pseudo,
        derniereModification: serverTimestamp(),
      })
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "modifierLePseudoDuMembreConnecte")
    }
  }

  async supprimerMembreEtPokemons(idMembre) {
    try {
      const docRefMembre = doc(this.bdd, "membres", idMembre)
      await deleteDoc(docRefMembre)

      await this.baseDeDonnees.pokemons.supprimerPokemons(idMembre)
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "supprimerMembreEtPokemons")
    }
  }

  async ajouterUnTokenDeNotificationPourUneConversation(idMembre) {
    if (typeof window === "undefined") {
      return null
    }

    if (!("Notification" in window) || Notification.permission !== "granted") {
      console.warn("Permission de notification absente")
      return null
    }

    const messaging = getMessaging(this.app)

    try {
      console.log("demande du token")

      let serviceWorkerRegistration
      if ("serviceWorker" in navigator) {
        serviceWorkerRegistration = await navigator.serviceWorker.ready
      }

      const token = await getToken(messaging, {
        vapidKey: "BCwFIlN73E3v8twaFHJ26IAg8jFbEJftuvtlbPpU31W2Q88RpA7zS6KImy6nf6j50EHJHF4IyA_NGUCcaQaljAU",
        serviceWorkerRegistration,
      })

      if (!token) {
        console.warn("Aucun token FCM recu")
        return null
      }

      const userRef = doc(this.bdd, "membres", idMembre)

      await updateDoc(userRef, {
        fcmToken: token,
      })

      console.log("L'adresse de notification est enregistree !")
      return token
    } catch (error) {
      console.error("Erreur :", error)
      return null
    }
  }

  async recupererLeTokenDeNotificationDuMembre(idMembre) {
    try {
      const docRefMembre = doc(this.bdd, "membres", idMembre)
      const snapshot = await getDoc(docRefMembre)
      if (snapshot.exists()) {
        const data = snapshot.data()
        return data.fcmToken || null
      }
      return null
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererLeTokenDeNotificationDuMembre")
    }
  }
}
